import { RouteObject } from 'react-router-dom';
import { ROUTE_APPEALS } from '../../../common/constants';
import { AppealsPage } from '../../../pages/admin/appeals-page';

export const appealRoutes: RouteObject = {
  path: ROUTE_APPEALS,
  element: <AppealsPage />,
};
